import { type Iteration } from '../models';
import IterationFilter from './IterationFilter';

/**
 * Special variant of the IterationFilter - if no records are provided,
 * filters against the provided current iteration.
 */
class WorkflowIterationFilter extends IterationFilter {
  currentIterationId?: RecordId;

  constructor(
    initialItems: RecordId[],
    initialOptions = [],
    filterOptions: { currentIterationId?: RecordId } = {}
  ) {
    super(initialItems, initialOptions, filterOptions);
    this.currentIterationId = filterOptions.currentIterationId;
  }

  matches(record: { iteration: Iteration }) {
    if (this.hasItems) {
      return super.matches(record);
    }
    return record.iteration && record.iteration.id === this.currentIterationId;
  }
}

export default WorkflowIterationFilter;
